import terms from 'i18n';

type FilterConfigInput = {
  defaultValues: Record<string, any>;
  labels?: Record<string, string>;
  supportExcluded?: string[];
};

const buildFilterConfig = (input: FilterConfigInput) => {
  const { defaultValues, labels = {}, supportExcluded = [] } = input;
  const allFilters = Object.keys(defaultValues);
  return { allFilters, labels, supportExcluded };
};

export const FILTER_CONFIG = {
  // заявления
  applications: buildFilterConfig({
    defaultValues: {
      userId: '',
      lastName: '',
      firstName: '',
      middleName: '',
      email: '',
      snils: '',
      directionPaymentFormId: undefined,
      directionEducationFormId: undefined,
      citizenshipIds: undefined,
      applicationState: undefined,
      applicationExpertStatus: undefined,
      applicationCoordinatorStatus: undefined,
      unreadMessages: undefined,
      directionName: '',
      facultyIds: undefined,
      recruitedIds: undefined,
      applicationEducationLevel: undefined,
      applicationTrajectory: undefined,
      serveMethods: undefined,
      educationProgram: undefined,
      creationDate: undefined,
      moderatorIds: undefined,
      applicationAdmissionCondition: undefined,
      uploadStatus: undefined,
      applicationChecklistState: undefined,
      originalDocumentSubmissionStatus: undefined,
      onlyForForeigners: undefined,
    },
    labels: {
      userId: 'ID СПБПУ / ID ЕПГУ',
      lastName: 'Фамилия',
      firstName: 'Имя',
      middleName: 'Отчество',
      email: 'Email',
      snils: 'СНИЛС',
      directionPaymentFormId: 'Основания поступления',
      directionEducationFormId: terms.MODE_OF_STUDY,
      citizenshipIds: terms.CITIZENSHIP,
      applicationState: 'Статус заявления',
      applicationExpertStatus: 'Статус эксперта',
      applicationCoordinatorStatus: 'Статус координатора',
      unreadMessages: 'Непрочитанные сообщения',
      directionName: 'Направление',
      facultyIds: 'Подразделение',
      recruitedIds: 'Партнер',
      applicationEducationLevel: 'Уровень подготовки',
      applicationTrajectory: 'Траектория поступления',
      serveMethods: 'Способ подачи',
      educationProgram: 'Программа',
      creationDate: 'Дата подачи заявления',
      moderatorIds: 'Сотрудник ПК',
      applicationAdmissionCondition: 'Особенности приема',
      uploadStatus: 'Состояние выгрузки в 1С',
      applicationChecklistState: 'Состояние чек-листа заявления',
      originalDocumentSubmissionStatus:
        'Наличие согласия на зачисление / оригинала ДОО',
      onlyForForeigners: 'Вид конкурсных групп',
    },
    supportExcluded: [
      'applicationState',
      'applicationExpertStatus',
      'applicationCoordinatorStatus',
    ],
  }),

  // договоры
  contracts: buildFilterConfig({
    defaultValues: {
      userId: '',
      lastName: '',
      firstName: '',
      middleName: '',
      email: '',
      directionName: '',
      directionEducationFormIds: undefined,
      citizenshipCountryIds: undefined,
      applicationsStates: undefined,
      contractStates: undefined,
      facultyIds: undefined,
      applicationTrajectories: undefined,
      informing: undefined,
      isOnline: undefined,
      signedContractReceived: undefined,
      contractCopyGivenToApplicant: undefined,
      paymentMethods: undefined,
      contractTypes: undefined,
      hasClaim: undefined,
      applicationEducationLevel: undefined,
      educationProgram: undefined,
    },
    labels: {
      userId: 'ID СПБПУ / ID ЕПГУ абитуриента',
      lastName: 'Фамилия',
      firstName: 'Имя',
      middleName: 'Отчество',
      email: 'Email',
      directionEducationFormIds: terms.MODE_OF_STUDY,
      citizenshipCountryIds: terms.CITIZENSHIP,
      applicationsStates: 'Статус заявления',
      contractStates: 'Статус договора',
      directionName: 'Направление',
      educationProgram: 'Программа',
      facultyIds: 'Подразделение',
      serveMethods: 'Способ подачи',
      recruitedIds: 'Партнер',
      applicationEducationLevel: 'Уровень подготовки',
      applicationTrajectories: 'Приемная кампания',
      moderatorIds: 'Сотрудник ПК',
      informing: 'Информирование о зачислении',
      isOnline: 'Тип договора',
      signedContractReceived: 'Контракт получен с подписью',
      contractCopyGivenToApplicant: 'Экземпляр контракта передан абитуриенту',
      paymentMethods: 'Особенности оплаты',
      contractTypes: 'Плательщик',
      hasClaim: 'Претензия поступающего',
    },
    supportExcluded: [],
  }),

  //лог действий
  logs: buildFilterConfig({
    defaultValues: {
      applicationId: '',
      applicantId: '',
      actorId: '',
      actorRole: undefined,
      startDate: '',
      endDate: '',
      eventType: undefined,
      eventTypeHead: undefined,
      message: '',
    },
    labels: {
      applicationId: 'ID заявления',
      applicantId: 'ID владельца заявления',
      actorId: 'ID инициатора',
      actorRole: 'Роль инициатора',
      startDate: 'Дата начала',
      endDate: 'Дата окончания',
      eventType: 'Тип события',
      eventTypeHead: 'Обобщенный тип',
      message: 'Сообщение',
    },
    supportExcluded: [],
  }),

  //все пользователи
  users: buildFilterConfig({
    defaultValues: {
      id: '',
      lastName: '',
      firstName: '',
      middleName: '',
      email: '',
      active: null,
      role: null,
    },
    labels: {
      id: 'ID пользователя',
      lastName: 'Фамилия',
      firstName: 'Имя',
      middleName: 'Отчество',
      email: 'Email',
      active: 'Статус',
      role: 'Роль',
    },
    supportExcluded: [],
  }),

  //выгрузка данных
  upload_queue: buildFilterConfig({
    defaultValues: {
      id: '',
      lastName: '',
      firstName: '',
      middleName: '',
      email: '',
      hasError: null,
      fromEpgu: null,
    },
    labels: {
      id: 'ID пользователя',
      lastName: 'Фамилия',
      firstName: 'Имя',
      middleName: 'Отчество',
      email: 'Email',
      hasError: 'Состояние выгрузки',
      fromEpgu: 'Из ЕПГУ',
    },
    supportExcluded: [],
  }),

  //ведомости
  registries: buildFilterConfig({
    defaultValues: {
      campaignName: '',
      subjectTitle: '',
      dateOfTest: '',
      timeOfTest: '',
      uploadStatus: null,
    },
    labels: {
      campaignName: 'Название Приемной кампании',
      subjectTitle: 'Название предмета',
      dateOfTest: 'Дата экзамена',
      timeOfTest: 'Время экзамена',
      uploadStatus: 'Состояние выгрузки',
    },
    supportExcluded: [],
  }),

  //константы
  externals: buildFilterConfig({
    defaultValues: {
      type: { value: '', label: '' },
      id: '',
      name: '',
      deletedAt: null,
      externalId: '',
    },
    labels: {
      type: 'Тип выгрузки',
      id: 'ID',
      name: 'Название',
      deletedAt: 'Удален',
      externalId: 'Внешний ID',
    },
    supportExcluded: [],
  }),

  //очередь ведомстей
  statement_uploads: buildFilterConfig({
    defaultValues: {
      id: '',
      uploadStatus: null,
    },
    labels: {
      id: 'ID пользователя',
      uploadStatus: 'Статус выгрузки',
    },
    supportExcluded: [],
  }),

  //загружаемые документы
  applications_uploads: buildFilterConfig({
    defaultValues: {
      id: '',
      authorUserId: '',
      type: undefined,
      status: undefined,
      createdAt: '',
    },
    labels: {
      id: 'ID загрузки',
      authorUserId: 'ID автора',
      type: 'Тип',
      status: 'Статус',
      createdAt: 'Дата создания',
    },
    supportExcluded: [],
  }),
} as const;
